import { useEffect, useState } from "react";

const navItems = [
  { label: "事業内容", href: "#services" },
  { label: "選ばれる理由", href: "#strengths" },
  { label: "施工事例", href: "#works" },
  { label: "対応エリア", href: "#area" },
  { label: "会社概要", href: "#company" },
  { label: "お問い合わせ", href: "#contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 24);
      // Close mobile menu when user scrolls
      if (open && window.scrollY > 100) setOpen(false);
    };
    window.addEventListener("scroll", onScroll);
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, [open]);

  const handleAnchor = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    if (href.startsWith("#")) {
      e.preventDefault();
      const el = document.querySelector(href);
      if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
      setOpen(false);
    }
  };

  return (
    <header
      role="banner"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "bg-background-50/95 backdrop-blur-md border-b border-background-200/70"
          : "bg-transparent"
      }`}
    >
      <div className="w-full px-4 md:px-10 lg:px-14">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a
            href="#top"
            onClick={(e) => handleAnchor(e, "#top")}
            className="flex items-center gap-3 cursor-pointer"
          >
            <span
              className={`w-10 h-10 md:w-11 md:h-11 rounded-full flex items-center justify-center transition-colors ${
                scrolled ? "bg-primary-500" : "bg-background-50/90"
              }`}
            >
              <i
                className={`ri-home-4-line text-xl ${
                  scrolled ? "text-background-50" : "text-primary-700"
                }`}
              ></i>
            </span>
            <span className="flex flex-col leading-none">
              <span
                className={`text-[10px] tracking-[0.3em] uppercase ${
                  scrolled ? "text-foreground-500" : "text-background-50/80"
                }`}
              >
                Kabushiki-gaisha
              </span>
              <span
                className={`font-heading text-xl md:text-2xl font-bold tracking-wide ${
                  scrolled ? "text-foreground-950" : "text-background-50"
                }`}
              >
                Wind
              </span>
            </span>
          </a>

          {/* Desktop nav */}
          <nav role="navigation" aria-label="メインメニュー" className="hidden lg:flex items-center gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleAnchor(e, item.href)}
                className={`px-4 py-2 text-sm font-medium tracking-wide rounded-md transition-colors cursor-pointer whitespace-nowrap ${
                  scrolled
                    ? "text-foreground-700 hover:text-primary-600 hover:bg-primary-50"
                    : "text-background-50 hover:text-primary-200"
                }`}
              >
                {item.label}
              </a>
            ))}
            <a
              href="tel:0363792823"
              className="ml-3 inline-flex items-center gap-2 px-5 py-2.5 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
            >
              <i className="ri-phone-line"></i>
              03-6379-2823
            </a>
          </nav>

          {/* Mobile button */}
          <button
            onClick={() => setOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 rounded-md flex items-center justify-center cursor-pointer ${
              scrolled
                ? "text-foreground-900 hover:bg-background-100"
                : "text-background-50 hover:bg-background-50/10"
            }`}
            aria-label="menu"
          >
            <i className={`text-2xl ${open ? "ri-close-line" : "ri-menu-line"}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 ${
          open ? "max-h-[600px]" : "max-h-0"
        } bg-background-50 border-t border-background-200/70`}
      >
        <div className="px-4 py-4 flex flex-col gap-1">
          {navItems.map((item) => (
            <a
              key={item.href}
              href={item.href}
              onClick={(e) => handleAnchor(e, item.href)}
              className="px-4 py-3 text-sm font-medium text-foreground-800 hover:bg-primary-50 hover:text-primary-700 rounded-md cursor-pointer"
            >
              {item.label}
            </a>
          ))}
          <a
            href="tel:0363792823"
            className="mt-2 inline-flex items-center justify-center gap-2 px-5 py-3 rounded-full bg-primary-500 text-background-50 dark:text-foreground-950 text-sm font-semibold cursor-pointer whitespace-nowrap"
          >
            <i className="ri-phone-line"></i>
            お電話でのご相談 03-6379-2823
          </a>
        </div>
      </div>
    </header>
  );
}